export const items = [
    {
        date:'2025/06/15',
        src: require('/static/news/news1.jpg'),
        title:'中国医药物资协会零售药店大健康分会第47届高峰论坛在复盛公举行',
        subTitle:'6月14-15日，中国医药物资协会零售药店大健康分会（"中康会"）第47届高峰论坛在我公司举行。',
        content:'6月14-15日，中国医药物资协会零售药店大健康分会（"中康会"）第47届高峰论坛在我公司举行。本次大会主题是"突破边界，共生共享（跳出药圈看药店，走进消费创销售）"。会议吸引了包括全国医药行业同仁、供应商伙伴领导及团队、中康会117家会员单位、山西近20家医药连锁的董事长、总经理、商采负责人、运营负责人等约500人参加盛会。6月14日14:18分，大会在《祖国颂》嘹亮的歌声中正式拉开帷幕，中康会第47届高峰论坛大会主席陈虹女士开幕致辞。她表示，医药健康行业正经历三大边界变革：顾客边界消融、竞争边界重构、合作边界扩展。为此，医药行业应以晋商智慧和消费视角，"跳出药圈看药店，走进消费创销售"，以开放姿态拥抱变化，共探增长新路径。复盛公药业集团董事长宋辞先生为本次大会致辞，对出席大会的各位领导和同仁表示热烈的欢迎和衷心的感谢。他表示，中华老字号、百年复盛公期待与在座的各位同仁加强交流与合作，共同应对挑战，共享发展机遇。相信在大家的共同努力下，我们的医药事业一定能焕发出新的生机和活力，合作共赢，携手奋进。'
    },
   
    {
        date:'2025/08/12',
        src: require('/static/news/news3.jpg'),
        title:'2025铁军训练营第四期在山西祁县复盛公产业园召开',
        subTitle:'8月12日，2025铁军训练营第四期在山西祁县复盛公产业园召开，集团董事长宋辞先生出席了本次会议并发表讲话。',
        content:'8月12日 2025铁军训练营第四期在山西祁县复盛公产业园召开，吹响新的集结号。集团董事长宋辞先生出席了本次会议并发表讲话。宋辞先生表示，下半年要以三大战略为核心，推进 "实赋能、树样板、强动销" 市场攻坚，强化资源整合、优化运营效率，实现可持续增长。他在讲话中要求参训精英认真参与，保持积极向上的学习心态，为未来广阔的市场打下坚实的基础！铁军训练营四期延续了往期的风格，继续邀请实战经验丰富的讲师，以理论知识结合实例的方式，让参训学员能够以更清晰的思维、更全面的知识技能、更专业的业务能力为客户提供服务。在训练营中，还有多位精英讲师针对"T+Z"品类增利公式、"四维一体"药店赋能体系、药店创新盈利单项、引流利器等实际问题，进行了详细分析与推演，并邀请学员进行互动学习，现场学习气氛浓厚、学员收获满满。'
    },
    {
        date:'2025/08/18',
        src: require('/static/news/news4.jpg'),
        title:'市长刘星在祁县调研时强调：做强特色产业赋能县域经济转型 推动老字号守正创新发展',
        subTitle:'市长刘星赴祁县调研，强调要深入学习贯彻中央及省委精神，聚焦市委“156”战略，通过做强特色产业、加强品牌建设推动县域经济转型，并指出老字号企业要坚持守正创新，提升品牌价值与竞争力。',
        content:'8月18日，市委副书记、市长刘星在祁县调研。他强调，要深入学习贯彻习近平总书记考察山西重要讲话重要指示精神，认真贯彻落实省委十二届十次全会精神，锚定市委“156”战略举措，做强特色产业，加强品牌建设，赋能县域经济转型发展，为奋力谱写三晋大地推进中国式现代化晋中新篇章作出新贡献。副市长张王杰参加。山西复盛公药业集团是集研发、生产、营销为一体的综合性医药产业集团，2024年荣获“中华老字号”称号。刘星详细了解企业品牌历程、产品特色、市场销售等情况，他指出，老字号是中华优秀传统文化中的瑰宝，是集历史、文化、商业、信誉为一体的“金字招牌”。要坚持守正创新，更新发展理念，用好本地资源，延伸产业链条，推动多元化发展，努力用好原料、好工艺生产好产品、传承好品牌。要深入挖掘老字号品牌经济价值、文化价值、社会价值，加强技术创新、产品创新、营销创新，不断提升老字号品牌的竞争力、美誉度、影响力，用品牌占领市场和引领生产。'
    },
    {
        date:'2025/09/03',
        src: require('/static/news/new5.jpg'),
        title:'复盛公组织开展阅兵观礼活动',
        subTitle:'9月3日，组织开展阅兵观礼活动，董事长宋辞先生出席活动并发表致辞',
        content:'9月3日，组织开展阅兵观礼活动，董事长宋辞先生出席活动并发表致辞。他强调，全体员工要深入学习革命先烈精神以及阅兵精神，汲取前进力量，为企业发展和社会进步贡献力量。此次观礼活动，不仅是对历史的铭记和对先烈的缅怀，更是一次深刻的爱国主义教育和精神洗礼，激励着复盛公药业集团全体员工在新时代新征程上奋勇前进，为实现中华民族伟大复兴的中国梦而努力奋斗。'
    },
    
]

export const businessItems = [
  {
    date:'2025-07-21',
    src: require('/static/news/b3.png'),
    title:'国家药监局 公安部 国家卫生健康委关于发布药用类麻醉药品和精神药品目录的公告（2025年第55号）',
    content:'7月21日  国家药监局 公安部 国家卫生健康委关于发布药用类麻醉药品和精神药品目录的公告（2025年第55号）根据《麻醉药品和精神药品管理条例》第三条规定，国家药监局、公安部、国家卫生健康委制定了药用类麻醉药品目录（2025年版）和药用类精神药品目录（2025年版）（见附件），现予以发布，自发布之日起施行。'
  },
  {
      date:'2025-08-29',
      src: require('/static/news/b1.jpg'),
      title:'国家药监局关于莲芝消炎软胶囊和肾骨片转换为非处方药的公告（2025年第84号）',
      content:'7月21日  国家药监局 公安部 国家卫生健康委关于发布药用类麻醉药品和精神药品目录的公告（2025年第55号）根据《麻醉药品和精神药品管理条例》第三条规定，国家药监局、公安部、国家卫生健康委制定了药用类麻醉药品目录（2025年版）和药用类精神药品目录（2025年版）（见附件），现予以发布，自发布之日起施行。'
  },
  {
      date:'2025-04-28',
      src: require('/static/news/b2.png'),
      title:'《医疗器械网络销售质量管理规范》',
      content:'2025年4月28日为加强医疗器械网络销售监督管理，规范医疗器械网络销售质量管理，保障公众用械安全有效，促进医疗器械产业发展，根据相关法规规章规定，国家药监局制定了《医疗器械网络销售质量管理规范》，现予发布，自2025年10月1日起施行。'
  },
   {
      date:'2025-03-25',
      src: require('/static/news/b4.png'),
      title:'国家药监局关于实施2025年版《中华人民共和国药典》有关事宜的公告（2025年第32号）',
      content:'2025年3月25日国家药监局关于实施2025年版《中华人民共和国药典》有关事宜的公告（2025年第32号）<br/>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;2025年版《中华人民共和国药典》（以下简称《中国药典》）已由国家药监局、国家卫生健康委2025年第29号公告颁布，自2025年10月1日起实施。现就实施本版《中国药典》有关事宜公告如下：<br/>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;一、根据《药品管理法》规定，药品应当符合国家药品标准。《中国药典》是国家药品标准的重要组成部分，是药品研制、生产（进口）、经营、使用和监督管理等相关单位均应当遵循的法定技术标准。<br/>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;二、《中国药典》主要包括凡例、品种正文、通用技术要求和指导原则。自实施之日起，所有药品上市许可持有人及生产上市的药品应当执行本公告和本版《中国药典》相关要求。其中，指导原则相关要求为推荐技术要求。<br/>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;三、自实施之日起，凡原收载于历版药典、局（部）颁标准的品种，本版《中国药典》收载的，相应历版药典、局（部）颁标准同时废止；本版《中国药典》未收载的，仍执行相应历版药典、局（部）颁标准，但应当符合本版《中国药典》的相关通用技术要求。经上市后评价撤销或者注销的品种，相应历版药典、局（部）颁标准废止.........'
  },
  
]

export const zxcy = [
    {
        src: require('/static/products/zxcy/a1.png'),
        name:'药品名称：大山楂丸',
        pzwh:'批准文号：国药准字Z13020382',
        gg:'规格：9g*6丸',
        scqy:'生产企业：山西复盛公大药厂有限公司',
        gnzz:'功能主治：开胃消食。用于食积内停所致的食欲不振、消化不良、脘腹胀闷。',
        yl:'用法用量：口服，一次1-2丸，一日1-3次；小儿酌减。'
    },
    {
        src: require('/static/products/zxcy/a2.png'),
        name:'药品名称：外感平安茶',
        pzwh:'批准文号：国药准字Z14020341',
        gg:'规格：7g*6袋',
        scqy:'生产企业：山西复盛公大药厂有限公司',
        gnzz:'功能主治：清热解表，化湿消滞。用于四时感冒，恶寒发热，周身骨痛，头重乏力，感冒挟湿，胸闷食滞等症。',
        yl:'用法用量：开水冲服，一次7克，一日2~3次。'
    },
    {
        src: require('/static/products/zxcy/a3.png'),
        name:'药品名称：六味地黄丸',
        pzwh:'批准文号：国药准字Z21020552',
        gg:'规格：380丸/瓶*2瓶',
        scqy:'生产企业：山西复盛公大药厂有限公司',
        gnzz:'功能主治：滋阴补肾。用于肾阴亏损，头晕耳鸣，腰膝酸软，骨蒸潮热，盗汗遗精。',
        yl:'用法用量：口服。一次8丸，一日3次。'
    },
    {
        src: require('/static/products/zxcy/a4.png'),
        name:'药品名称：益母草颗粒',
        pzwh:'批准文号：国药准字Z45021405',
        gg:'规格：15g*10袋',
        scqy:'生产企业：山西复盛公大药厂有限公司',
        gnzz:'功能主治：活血调经。用于血瘀所致的月经不调，症见经水量少、淋漓不净。',
        yl:'用法用量：开水冲服，一次1袋，一日2次。'
    },
    {
        src: require('/static/products/zxcy/a5.png'),
        name:'药品名称：板蓝根颗粒',
        pzwh:'批准文号：国药准字Z13022024',
        gg:'规格：10g*18袋',
        scqy:'生产企业：山西复盛公大药厂有限公司',
        gnzz:'功能主治：清热解毒，凉血利咽。用于肺胃热盛所致的咽喉肿痛、口咽干燥、腮部肿胀；急性扁桃体炎、腮腺炎见上述证候者。',
        yl:'用法用量：开水冲服。一次5~10克（含蔗糖），一日3~4次。'
    },
    {
        src: require('/static/products/zxcy/a6.png'),
        name:'药品名称：藿香正气丸',
        pzwh:'批准文号：国药准字Z22023676',
        gg:'规格：120丸',
        scqy:'生产企业：山西复盛公大药厂有限公司',
        gnzz:'功能主治：解表退热，和中理气。用于暑湿感冒，头痛身重胸闷，或恶寒发热，脘腹胀痛，呕吐泄泻。',
        yl:'用法用量：口服。一次8丸，一日3次。'

    },
  
]
export const ylqx = [
  
  {
      src: require('/static/products/ylqx/a1.png'),
      name:'器械名称：医用退热贴',
        bapzh:'备案凭证号：粤江械备20150018号',
        gg:'规格型号：120mm*50mm*4贴',
        scqy:'生产企业：江门市新时代外用制剂有限公司',
        yylx:'适用范围：适用于婴儿、儿童和成人感冒引起发热的物理降温。',
        yl:'',
  },
  {
      src: require('/static/products/ylqx/a2.png'),
      name:'器械名称：颈肩腰腿痛贴',
      bapzh:'注册证号：皖械注准20172090034',
      gg:'规格型号：3贴/袋*2袋（70mm*100mm）',
      scqy:'生产企业：安徽金牛药械股份有限公司',
      yylx:'适用范围：风寒邪湿引起的颈肩腰痛肌肉关节疼痛的辅助治疗。',
      yl:'',
  },
  {
      src: require('/static/products/ylqx/a3.png'),
      name:'器械名称：伤口贴（超弹防水透气型）',
      bapzh:'备案凭证号：鄂黄石械备20150007号',
      gg:'规格型号：5片/袋*20袋',
      scqy:'生产企业：黄石天行健医疗器械有限公司',
      yylx:'适用范围：该产品主要应用于浅表性小创伤擦伤等的贴敷。',
  }
 
]
export const spbj = [
 
  {
      src: require('/static/products/bjsp/a1.png'),
      name:'产品名称：黑芝麻核桃阿胶糕（红枣枸杞）',
      
cptd:'',
hxyl:'核心原料与功效：1、阿胶：补血滋阴、润燥止血，改善气血不足，增强免疫力。2、黑芝麻：乌发养颜、补肾益精，富含钙质和维生素E。3、核桃仁：健脑益智、抗氧化，含Omega-3脂肪酸，助力心脑血管健康。4、红枣：补中益气、养血安神，富含铁元素，适合女性调理。5、枸杞：明目护肝、抗衰老，提升机体抵抗力。',
spjy:'',
zysx:''


  },
  {
      src: require('/static/products/bjsp/a2.png'),
      name:'产品名称：羊乳蛋白质粉固体饮料',
      
      cptd:'',
      hxyl:'核心原料与功效：1、羊乳蛋白质：富含蛋白质、脂肪、碳水化合物和维生素等营养元素，对身体的生长发育和功能起到重要作用。2、蛋白粉：蛋白质粉是由蛋白质经发酵、发酵后再经处理得到的，富含蛋白质、脂肪、碳水化合物和维生素等营养元素，对身体的生长发育和功能起到重要作用。',
      spjy:'',
      zysx:''
  },
  {
      src: require('/static/products/bjsp/a3.png'),
      name:'产品名称：枇杷秋梨膏',
      hxyl:'核心原料与功效：梨汁、蜂蜜、枇杷叶、罗汉果、菊花、桔梗、甘草、胖大海、陈皮。建议一日两次，每次10-15克，直接食用或适量温开水冲饮。枇杷叶食用量≤10克/天。',
      spjy:'',
      zysx:'',
  }
]

